<template>
  <div id="func-53">
    <span v-if="!beneficiarioSelecionado" class="title align-title">{{titulo}}</span>
  <GrupoFamiliar
    v-model="beneficiarioSelecionado"
    :style="beneficiarioSelecionado ? 'min-height: 600px' : ''"
    id-funcionalidade="53"
    @contratos="defineResponsavelAtendimento"
  >
      <StepFormulario
        :paciente="dadosContato"
        v-if="beneficiarioSelecionado"
        @submit="submitForm"
      />
  </GrupoFamiliar>
  </div>
</template>
<script>
import GrupoFamiliar from '@/components/GrupoFamiliar/GrupoFamiliar'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import StepFormulario from '@/views/53/Steps/StepFormulario'
export default {
  data () {
    return {
      beneficiarioSelecionado: null,
      dadosContato: null,
      form: {}
    }
  },
  watch: {
    beneficiarioSelecionado: function (newVal) {
      const payload = {
        nome: newVal.beneficiarioDados.dadosPessoais.nome,
        contato: newVal.beneficiarioDados.dadosPessoais.contato,
        chaveUnica: newVal.beneficiarioDados.chaveUnica,
        numeroContrato: newVal.beneficiarioDados.dadosDoContrato.numeroContrato,
        tipoUser: newVal.beneficiarioDados.dadosDoPlano.tipoUsuario.descricao,
        integracao: newVal.beneficiarioDados.integracao
      }
      this.setPaciente(payload)

      /**
       * Se o agendamento for presencial, então seta os dados de contato para o beneficiario selecionado
       */
      if (this.idAgenda === '1') {
        this.dadosContato = newVal
      }
    }
  },
  methods: {
    ...mapActions('Func53', ['setPaciente', 'setDadosContato', 'setResponsavelAtendimento']),
    ...mapActions('BreadCrumbsStore', ['updateIten']),
    ...mapMutations('BreadCrumbsStore', ['SET_CURRENT_STEP']),
    submitForm (payload) {
      this.setDadosContato(payload)
      const nextStep = parseInt(this.$route.query.step) + 1
      this.$router.replace({ query: { step: nextStep } })
    },
    defineResponsavelAtendimento (contratos) {
      /**
       * Para a função se o agendamento for de consulta presencial
       */
      if (this.idAgenda === '1') {
        return false
      }
      /**
       * Recebe contratos e define o responsável pelo atendimento como usuário que está logado
       */
      const responsavelAtendimento = this.beneficiarios.find((beneficiario) => beneficiario.chaveUnica === this.user.chaveUnica)

      this.setResponsavelAtendimento({
        nome: responsavelAtendimento.nome,
        contato: responsavelAtendimento.dadosPessoais.contato,
        chaveUnica: responsavelAtendimento.chaveUnica,
        numeroContrato: responsavelAtendimento.numeroContrato,
        integracao: responsavelAtendimento.integracao || null
      })

      /**
       * Define dados de contato do formulário
       */
      const contrato = contratos.find((el, i) => {
        return el.contrato === responsavelAtendimento.dadosDoContrato.numeroContrato
      })
      this.dadosContato = contrato.data.find((data) => data.chaveUnica === responsavelAtendimento.chaveUnica)
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapState('Func53', ['idAgenda']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapGetters('Login', ['user', 'beneficiarios']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    titulo () {
      return this.funcionalidade.parametros.textos.tituloSelecaoPaciente
    }
  },
  components: {
    StepFormulario,
    GrupoFamiliar
  },
  created () {
    this.SET_CURRENT_STEP(1)
  }
}
</script>
<style lang="less">
</style>
